import { Header } from "../components/header";
import LeavesLeft from "../assets/leaves-left.png";
import Tomatoes from "../assets/tomatoes.png";
import MangroveGreenPeas from "../assets/mangrove-green-peas.png";
import MangroveSweetCorn from "../assets/mangrove-sweet-corn.png";
import FullColorFlavorImg from "../assets/full-color-flavor.png";
import Beans from "../assets/beans.png";
import LeavesRight from "../assets/leaves-right.png";
import Corn from "../assets/corn.png";
import MangroveProducts from "../assets/mangroove-products.png";
import Peas from "../assets/peas.png";
import PepperNut from "../assets/pepper-nut.png";
import Carousel from "react-multi-carousel";
import React, { useEffect, useState } from "react";
import { Footer } from "../components/footer";
import { trackPageView } from "../utils/segment";
import { toast } from "react-toastify";
import { createClient } from "contentful";
import { PageLoadingShimmer } from "../components/page-loading";

export function LandingPage() {
  const [recipes, setRecipes] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  const client = createClient({
    space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
    accessToken: process.env.REACT_APP_CONTENTFUL_API_KEY,
  });

  const fetchRecipes = async () => {
    try {
      const { items } = await client.getEntries({
        content_type: "recipes",
        order: "sys.createdAt",
      });
      setRecipes(items.splice(0, 5));
      setPageLoading(false);
    } catch (error) {
      console.log("eree", error);
      toast.error("There was a problem fetching recipes");
      setPageLoading(false);
    }
  };

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      // Wait a bit in case the DOM hasn't rendered the section yet
      setTimeout(() => {
        const element = document.getElementById(hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100); // 100ms delay to ensure content is mounted
    }
  }, []);

  useEffect(() => {
    trackPageView("Viewed Landing Page");
    fetchRecipes();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="landing-page">
      {pageLoading ? <PageLoadingShimmer /> : null}
      <Header />
      <div className="">
        {/* <div className="container-fluid"> */}
        <div className="hero-section">
          <div className="hero-section-content">
            <img
              className="hero-section-img _left-leaves"
              src={LeavesLeft}
              alt="Leaves Left"
            />
            <img
              className="hero-section-img _tomatoes"
              src={Tomatoes}
              alt="Tomatoes"
            />
            <img
              className="hero-section-img _full-color-flavor"
              src={FullColorFlavorImg}
              alt="Full Color Flavor"
            />
            <img className="hero-section-img _beans" src={Beans} alt="Beans" />
            <img
              className="hero-section-img _leaves-right"
              src={LeavesRight}
              alt="Leaves Right"
            />
            <img className="hero-section-img _corn" src={Corn} alt="Corn" />
            <a href="/where-to-buy">
              <button>
                <p>Where to Buy</p>
                <i className="bi bi-chevron-right"></i>
              </button>
            </a>
          </div>
        </div>
        <div className="products-range" id="products-range">
          <h5>Explore our range</h5>
          <div className="">
            <div className="products">
              <img
                src={MangroveSweetCorn}
                alt="sweet corn"
                className="img-fluid"
              />
              <img
                src={
                  "https://images.ctfassets.net/b9z5sch0zany/uw8Sa1f0N1XiG6KYyCPpN/c200642270d721a490b8934aa883b8da/MANGROVE_CANS_SARDINES.png"
                }
                alt="sardines"
                className="img-fluid"
              />
              <img
                src={
                  "https://images.ctfassets.net/b9z5sch0zany/2AbCvvdQhmmwthp7Gq2jUc/565dff0f1e2e7c75b16291598597feba/MANGROVE_CAN_BAKED-BEANS.png"
                }
                alt="baked beans"
                className="img-fluid"
              />
              <img src={MangroveGreenPeas} alt="peas" className="img-fluid" />
              <img
                src={
                  "https://images.ctfassets.net/b9z5sch0zany/4ksgBaRv2XA0THoABxBGU5/5974040fea3caea221d21d45d78cab0d/MANGROVE_CAN_MACKEREL.png"
                }
                alt="mackerel"
                className="img-fluid"
              />
            </div>
            <div className="discover-more-btn">
              {/* <button>
                <p>Discover More</p>
                <i className="bi bi-chevron-right"></i>
              </button> */}
            </div>
          </div>
        </div>
        <div className="about-mangrove" id="about-us">
          <h5>About Mangrove Foods</h5>
          <img src={Peas} alt="Peas" className="img-fluid side-img peas" />
          <h6>
            Everyone at Mangrove Foods works hard to bring you high-quality
            ingredients from across the tropics direct to your door. From rice
            and traditional flours to palm oil and fine spices, our passion for
            food is in every colourful bite.
          </h6>
          <img
            src={MangroveProducts}
            alt="Mangrove Products"
            className="img-fluid"
          />
          <div className="about-mangrove-block-2"></div>
          <img
            src={PepperNut}
            alt="Pepper Nut"
            className="img-fluid side-img pepper-nut"
          />
        </div>
        <div className="our-recipes">
          <h5>Mangrove Recipes</h5>
          <div className="our-recipes-content">
            <Carousel
              arrows={false}
              autoPlay={true}
              autoPlaySpeed={5000}
              centerMode={false}
              draggable={true}
              showDots={true}
              responsive={responsive}
              dotListClass="custom-dot-list-style"
              renderDotsOutside={true}
              infinite={true}
            >
              {recipes.map((recipe, key) => (
                <div className="our-recipes-content-item" key={key}>
                  <div className="our-recipes-content-item-img">
                    <img
                      src={recipe.fields.foodImage.fields.file.url}
                      alt={recipe.fields.foodImage.fields.title}
                      className="img-fluid"
                    />
                  </div>
                  <div className="our-recipes-content-item-text">
                    <h6>{recipe.fields.foodName}</h6>
                    <p>{recipe.fields.description}</p>
                    <button
                      onClick={() =>
                        (window.location.href = `/recipes?food=${recipe.fields.foodName}`)
                      }
                    >
                      <p>See Recipe</p>
                      <i className="bi bi-chevron-right"></i>
                    </button>
                  </div>
                </div>
              ))}
            </Carousel>
          </div>

          {recipes.length ? (
            <div className="more-recipes-btn-container">
              <button
                className="more-recipes-btn"
                onClick={() => (window.location.href = "/recipes")}
              >
                <p>All Recipes</p>
                <i className="bi bi-chevron-right"></i>
              </button>
            </div>
          ) : null}
        </div>
        <Footer />
      </div>
    </div>
  );
}
